import ACHHistoryPage from "components/pages/ACHHistoryPage";

export default function CaptureACHHistory(props) {
    return <ACHHistoryPage />
}